function initServiceCards() {
	const serviceCards = document.querySelectorAll(
		'.wp-block-metawood-service-card'
	);
	if (!serviceCards.length) return;

	let currentlyActive = null;

	serviceCards.forEach((serviceCard) => {
		const description = serviceCard.querySelector('.description');
		if (!description) return;

		// Create a separate animation for this card
		const heightAnimation = gsap.fromTo(
			description,
			{
				height: 0,
				marginBottom: 0,
			},
			{
				paused: true,
				height: () => description.scrollHeight,
				marginBottom: 20,
				onComplete: () =>
					gsap.set(description, {
						height: 'auto',
					}),
			}
		);

		const toggleDescription = () => {
			const isExpanded =
				description.ariaExpanded == 'true' ? true : false;

			if (currentlyActive && currentlyActive !== heightAnimation) {
				currentlyActive.reverse();
				currentlyActive._el.ariaExpanded = 'false';
			}

			if (!isExpanded) {
				description.ariaExpanded = 'true';
				heightAnimation.play();
				currentlyActive = heightAnimation;
				currentlyActive._el = description;
			}
		};

		serviceCard.addEventListener('mouseenter', toggleDescription);
		serviceCard.addEventListener('focus', toggleDescription);
	});
}

initServiceCards();
